import React from 'react';
import { useLogin } from '../../../common/providers_services/LoginProvider';
import { Divider, Form } from './styled';
import { FlexCol } from '../../../shared/FlexCol';
import { Body, Headline } from '../../../shared/styled-components/styled_text';
import { Naver } from './Naver';
import { Google } from './Google';
import { Kakao } from './Kakao';
import { Apple } from './Apple';
import { FlexRow } from '../../../shared/FlexRow';
import { IconInput } from '../../../shared/components/IconInput';
import { FilledButton, TextButton } from '../../../shared/styled-components/styled_buttons';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../../AppRoutes';

export const LoginForm: React.FC = () => {
  const {
    leadText,
    formRef,
    userId,
    setUserId,
    password,
    setPassword,
    userIdError,
    passwordError,
    submitEmailPassword,
    goSignUp,
    setSocial,
    onToken,
    showApple,
  } = useLogin();
  const navigate = useNavigate();
  const isDisabled = !userId.trim() || !password.trim();

  return (
    <Form ref={formRef} onSubmit={submitEmailPassword}>
      <>
        <FlexCol align={'flex-start'} width={'100%'} gap={'0.2rem'}>
          <Headline size={'m'}>캔디데이트 비즈에서</Headline>
          <Body size={'l'} style={{ color: 'var(--mono-40)' }}>
            {leadText}
          </Body>
        </FlexCol>

        <FlexCol align={'center'} width={'100%'} gap={'1.2rem'}>
          <FlexCol width={'100%'} align={'flex-start'} gap={'1.2rem'}>
            <Naver onSocial={setSocial} onToken={onToken} />
            <Google onSocial={setSocial} onToken={onToken} />
            <Kakao onSocial={setSocial} onToken={onToken} />
            {showApple && <Apple onSocial={setSocial} onToken={onToken} />}
          </FlexCol>
        </FlexCol>

        <FlexRow width={'100%'} gap={'1rem'}>
          <Divider />
          <Body size={'s'} style={{ color: 'var(--mono)' }}>
            또는
          </Body>
          <Divider />
        </FlexRow>

        <FlexCol width={'100%'} align={'center'} gap={'1.6rem'}>
          <FlexCol align={'flex-start'} width={'100%'} gap={'0.8rem'}>
            <IconInput
              id={'login-inp'}
              value={userId}
              onChange={setUserId}
              placeholder={'아이디(이메일)를 입력해주세요.'}
              style={{ width: '100%' }}
              errorMessage={userIdError}
              autocomplete={true}
              required={true}
            />
            <IconInput
              value={password}
              onChange={setPassword}
              placeholder={'비밀번호를 입력해주세요.'}
              icons={{
                end2: {
                  src: '/images/common/cancel_circle.svg',
                  onClick: () => setPassword(''),
                  needsInput: true,
                },
              }}
              style={{ width: '100%' }}
              required={true}
              errorMessage={passwordError}
              type={'password'}
            />
          </FlexCol>

          <FlexCol align={'flex-start'} width={'100%'} gap={'2.4rem'}>
            <FilledButton size={'m'} color={'primary'} style={{ width: '100%' }} disabled={isDisabled} type={'submit'}>
              로그인
            </FilledButton>

            <FlexRow gap={'0.4rem'}>
              <TextButton size={'s'} color={'mono'} onClick={goSignUp} type={'button'}>
                회원가입
              </TextButton>
              <span style={{ fontSize: '1.4rem', color: 'var(--mono-60)' }}>|</span>
              <TextButton size={'s'} color={'mono'} onClick={() => navigate(appRoutes.editPassword.path())} type={'button'}>
                비밀번호 변경
              </TextButton>
            </FlexRow>
          </FlexCol>
        </FlexCol>
      </>
    </Form>
  );
};
